module.exports = __webpack_public_path__ + "img/stopmarker-min.30012d9e.png";